export default __webpack_public_path__ + "static/media/oscer-pres-haematuria.ae06c1f4.svg";